import "./formSearch.scss";

import PropTypes from "prop-types";
import React, { createRef, PureComponent } from "react";

import Icon from "../interface/Icon";
import { withPortalChildContext } from "../portal/PortalChildContext";
import FormTextField from "./FormTextField";

class FormSearchField extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this._fieldRef = createRef();
  }

  focus() {
    if (this._fieldRef && this._fieldRef.current) {
      this._fieldRef.current.focus();
    }
  }

  render() {
    const rightIconCount =
      (this.props.showClearIcon ? 1 : 0) +
      (this.props.showCaseSensitiveIcon ? 1 : 0) +
      (this.props.showWholeWordIcon ? 1 : 0);

    let classNames = ["formSearchField"];
    if (this.props.disabled) {
      classNames.push("disabled");
    }
    if (this.props.showSearchIcon) {
      classNames.push("withSearchIcon");
    }
    classNames.push(`rightIcons${rightIconCount}`);

    return (
      <div className={classNames.join(" ")}>
        <FormTextField
          ref={this._fieldRef}
          disabled={this.props.disabled}
          onChange={this.props.onChange}
          onDownArrow={this.props.onDownArrow}
          continuouslyUpdates={this.props.continuouslyUpdates}
          value={this.props.value}
          placeholder={this.props.placeholder}
          autoFocus={this.props.autoFocus}
          disableAutoComplete={true}
          disableSpellCheck={true}
        />
        {this.props.showSearchIcon ? <Icon icon="smallSearch" className="searchIcon" color="iconMono" /> : null}
        {this.props.showCaseSensitiveIcon ? (
          <Icon
            icon="searchCase"
            className="caseIcon"
            color={this.props.caseSensitive ? "iconActive" : "iconMid"}
            onClick={() =>
              this.props.onCaseSensitiveChange ? this.props.onCaseSensitiveChange(!this.props.caseSensitive) : null
            }
            tooltip={this.props.caseSensitive ? "Disable case sensitivity" : "Enable case sensitivity"}
          />
        ) : null}
        {this.props.showWholeWordIcon ? (
          <Icon
            icon="searchWholeWord"
            className="wholeWordIcon"
            color={this.props.wholeWord ? "iconActive" : "iconMid"}
            onClick={() => (this.props.onWholeWordChange ? this.props.onWholeWordChange(!this.props.wholeWord) : null)}
            tooltip={this.props.wholeWord ? "Disable match whole word only" : "Enable match whole word only"}
          />
        ) : null}
        {this.props.showClearIcon ? (
          <Icon
            icon="clear"
            className="clearIcon"
            color="iconMono"
            onClick={() => (this.props.onChange ? this.props.onChange("") : null)}
          />
        ) : null}
      </div>
    );
  }
}

FormSearchField.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  caseSensitive: PropTypes.bool,
  wholeWord: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onDownArrow: PropTypes.func,
  continuouslyUpdates: PropTypes.bool,
  onCaseSensitiveChange: PropTypes.func,
  onWholeWordChange: PropTypes.func,

  showCaseSensitiveIcon: PropTypes.bool,
  showWholeWordIcon: PropTypes.bool,
  showSearchIcon: PropTypes.bool,
  showClearIcon: PropTypes.bool,

  // From withPortalChildContext
  portalChildContext: PropTypes.object
};

let Component = FormSearchField;
//#!if iOS === true
// Component = withPortalChildContext(Component);
//#!endif

export default Component;
